var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 1920 231"}},[_c('g',[_c('g',[_c('path',{staticClass:"bg-wave",attrs:{"d":"M0,156s619.76,5.76,975.66-44.24S1614,0,1920,0V231H0Z"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }